import { CommonModal } from "components";
import { utils } from "helper";
import React, { useState, useEffect } from "react";

export default function ImagePreview(props) {

    let { isOpen } = props;
    let preview = isOpen?.url?.split('.').at(-1);

    let inhanceProps = {
        ...props,
        previewImage: (preview === 'pdf' || preview === 'xlsx' || preview === 'xls' || preview === 'txt') ? false : true,
    }

    return (
        <div>
            <CommonModal {...inhanceProps}>
                {((preview === 'pdf' || preview === 'xlsx' || preview === 'xls' || preview === 'txt')) ?
                    <p className="p-3 m-2"> Sorry ⚠️ {utils.firstLetterCapital(preview)} preview is not available. Please download the file to view its contents.</p>
                    :
                    <img
                        src={isOpen?.url}
                        alt="Preview"
                        style={{
                            // width: "200px",
                            // height: "200px",
                            // objectFit: "cover",
                            borderRadius: "10px",
                            border: "2px solid #ccc",
                        }}
                    />}
            </CommonModal>
            <div className='offBack_drop'></div>
        </div>
    );
}